import { ArrowRight, ExternalLink, GraduationCap } from "lucide-react";
import { Button } from "@/components/ui/button";

export const AUSBILDUNG_INTEREST = "Ausbildung Pflegefachkraft (3 Jahre) – Partnerschule Mönchengladbach";

export function prefillLeadForm() {
  const detail = {
    course_interest: AUSBILDUNG_INTEREST,
    message: "Ich interessiere mich für die 3-jährige Pflegeausbildung zum 01.11. bei der Partnerschule in Mönchengladbach.",
  };
  try { sessionStorage.setItem("dh-lead-prefill", JSON.stringify(detail)); } catch { /* ignore */ }
  window.dispatchEvent(new CustomEvent("dh-lead-prefill", { detail }));
  document.getElementById("kontakt")?.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function PartnerBanner() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20" data-testid="partner-banner">
      <div className="relative rounded-3xl bg-sage-deep overflow-hidden">
        <div aria-hidden="true" className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(110% 90% at 88% 8%, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0) 55%)" }} />
        <div className="relative p-8 md:p-12 lg:p-14 grid lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-8">
            <img
              src="/partner/nightingale-logo-weiss.png"
              alt="Nightingale Internationale Pflegeschule"
              data-testid="partner-banner-logo"
              className="h-9 md:h-11 w-auto object-contain mb-6 opacity-95"
              loading="lazy"
            />
            <div className="flex items-center gap-3 flex-wrap">
              <span className="font-poster text-[11px] uppercase tracking-[0.3em] font-bold text-cream-50">
                Partnerschule · Mönchengladbach
              </span>
              <span className="h-px w-12 bg-cream-50/50" />
              <span className="inline-flex items-center gap-1.5 bg-cream-50 text-espresso text-[11px] font-bold uppercase tracking-[0.14em] px-3.5 py-1.5 rounded-full">
                Start 01.11. · Plätze frei
              </span>
            </div>
            <h2 className="mt-5 font-magazine font-medium text-3xl md:text-[2.6rem] text-cream-50 leading-[1.12]">
              Ausbildungsplätze zum <span className="italic">1. November</span>.
            </h2>
            <p className="mt-4 text-cream-50/90 text-[15px] leading-[1.75] max-w-2xl">
              Unsere Partnerschule, die <strong className="font-semibold text-cream-50">Nightingale Internationale Pflegeschule</strong> in
              Mönchengladbach, hat noch freie Plätze für die 3-jährige, staatlich anerkannte Ausbildung zur
              Pflegefachfrau / zum Pflegefachmann. Kostenlos, mit Ausbildungsvergütung — wir stellen gern den Kontakt her.
            </p>
            <a href="https://nightingale-pflegeschule.de" target="_blank" rel="noreferrer"
              data-testid="partner-banner-school-link"
              className="mt-4 inline-flex items-center gap-1.5 text-[12.5px] font-semibold text-cream-50/80 hover:text-cream-50 underline underline-offset-4 decoration-cream-50/40 transition-colors">
              nightingale-pflegeschule.de <ExternalLink className="h-3.5 w-3.5" strokeWidth={1.8} />
            </a>
          </div>
          <div className="lg:col-span-4 flex lg:justify-end">
            <div className="rounded-2xl bg-cream-50 p-6 md:p-7 w-full lg:max-w-xs">
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-sage/20 text-sage-dark mb-4">
                <GraduationCap className="h-5 w-5" strokeWidth={1.8} />
              </span>
              <div className="text-[11px] uppercase tracking-[0.26em] text-sand-500 font-bold">3-jährige Ausbildung</div>
              <div className="font-magazine text-[1.5rem] text-sand-800 leading-[1.15] mt-1.5">Pflegefachfrau / Pflegefachmann</div>
              <Button onClick={prefillLeadForm} data-testid="partner-banner-cta"
                className="mt-5 w-full rounded-full bg-espresso hover:bg-espresso-hover text-cream-50 h-12 text-[12.5px] font-bold uppercase tracking-[0.12em] group transition-colors">
                Jetzt Platz sichern
                <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" strokeWidth={2.2} />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
